<template>
  <div class="container">
       <div class="title">
          <div>
              <span>费用金额</span>
          </div>
          <div>
              <a-icon type="info-circle" />
             本次付款总金额：<span></span>元整
          </div>
       </div>
       <!-- 循环费用明细 -->
        <div>
            <div v-for="(item1, index1) in costList" :key="index1" class="center">
                <div class="centerTop">
                    <div class="title">
                       <span>费用明细({{index1 + 1}})</span>
                    </div>
                    <div>
                       <a-button @click="deleteItem(index1)"> 删除 </a-button>
                    </div>
                </div>
             <a-form-model :model="item1"  ref="ruleFormFixation"  :label-col="labelCol"  :wrapper-col="wrapperCol">
            <a-row v-for="(item, index) in item1" :key="index">
              <a-col :span="24">
                <a-form-model-item :label="item.label" prop="orderCode" style="margin-top:10px;">
                    <!-- 输入框 -->
                    <a-input v-if="item.type == 'Text'" v-model="item.value" :placeholder="item.content" allowClear style="width:60%;"></a-input>
                    <!-- 时间选择 -->
                    <a-date-picker v-model="item.value" valueFormat="YYYY-MM-DD" :placeholder="item.content" allowClear v-if="item.type == 'Date'" style="width:60%;"/>
                    <!-- 单选 -->
                   <div  v-if="item.type == 'Redio'" >
                      <a-radio-group v-model="item.value" >
                        <a-radio value="1">
                             Sponsor
                        </a-radio>
                        <a-radio value="2">
                             Venue
                        </a-radio>
                    </a-radio-group>
                   </div>
                   <!-- 多行文本 -->
                    <a-input v-if="item.type == 'Textarea'" v-model="item.value" type="textarea" style="width:60%;"/>
                </a-form-model-item>
              </a-col>
            </a-row>
         </a-form-model>
       </div>
       <div class="feeDetail">
           <a-button class="addFee" type="dashed" icon="plus" block @click="addCost"> 增加费用明细 </a-button>
       </div>
     </div>
       
  </div>
</template>

<script>
export default {
   props: [
        'costList',
        'modelData'
    ],
    data() {
        return {
         labelCol: {
          span: 3,
         },
         wrapperCol: {
           span: 21,
         },
      //   costList: [{
      //        formData: [{
      //    orderId: '',
      //    value: undefined,
      //    title: '输入框',
      //    type: 'input',
      //    content: '请输入',
      // },
      // {
      //     orderName: '',
      //     value: undefined,
      //     title: '日期选择器',
      //     type: 'date',
      //     content: '请选择',
      // }],

      //       }],
       

        }
    },
    methods: {
      //添加费用明细
        addCost() {
          this.costList.push(this.modelData)

        },
      //删除费用明细
      deleteItem(index1) {
        this.costList.splice(index1, 1)

      }

    }

}
</script>

<style   lang="less" scoped>
.container {
    .title {
    font-weight: 700;
    margin-left: 0px;
    margin-bottom: 10px;
    color: black;
    display: flex;
    justify-content: space-between;
    margin-right: 20px;
    }
    
}
.centerTop {
    padding: 20px;
    display: flex;
    justify-content: space-between;

}
.feeDetail {
  display:flex;
  justify-content: center;
  .addFee {
      width: 60%;
      margin-top: 10px;
      border-color: #409EFF !important;
      color: #409EFF !important;
      margin-bottom: 20px;


      &:hover {
        background: #e2f1ff !important;
      }
}

}


</style>